import Carousel from 'react-bootstrap/Carousel';
// import ExampleCarouselImage from 'components/ExampleCarouselImage';
import slide1 from './images/slide1.jpg'
import slide2 from './images/slide2.jpg'
import slide3 from './images/slide3.jpg'
import slide4 from './images/slide4.jpg'
import slide5 from './images/slide5.jpg'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import icon from './images/location-dot-solid.svg'
import stamp from './images/stamp.png'
import Card from 'react-bootstrap/Card';
import image1 from './images/hot_coffee.png'
import image2 from './images/coldc.png'
import image3 from './images/hotc2.png'
import image4 from './images/mocktail.png'
import './home.css'
import one from './images/menu/menu1.png'
import two from './images/menu/menu2.png'
import three from './images/menu/menu3.png'
import four from './images/menu/menu4.png'
import step1 from './images/process/tree.png'
import step2 from './images/process/cherry.png'
import step3 from './images/process/greenseed.png'
import step4 from './images/process/beans.png'
import step5 from './images/process/powder.png'
import step6 from './images/process/cup.png'
import bean from './images/bean.png'
import { Link, useNavigate } from 'react-router-dom';
import NavigationBar from './nav';
import NewNav from './canvas';
import Aos from 'aos';
import "aos/dist/aos.css";
import { useEffect } from 'react';

function Home() {
  const menu = [
    { id: 1, name: "Coffee Drinks", image: image1, description: "Rich, aromatic blends of freshly brewed coffee.", link: "coffee" },
    { id: 2, name: "Cold Coffee & Frappe", image: image2, description: "Chilled, creamy, and refreshing coffee delights.", link: "frap" },
    { id: 3, name: "Hot Chocolates", image: image3, description: "Velvety smooth hot chocolate made with premium cocoa.", link: "hotc" },
    { id: 4, name: "Mocktails", image: image4, description: "Refreshing beverages bursting with fruity flavors and fizz.", link: "mock" },
  ]
  let navigate = useNavigate();
  const Move = () => {
    navigate("/product")
  }
  const Read = () => {
    navigate("/about")
  }
  const Con = () => {
    navigate("/contact")
  }
   useEffect(()=>{
      Aos.init({duration:"1000"})
    })
  return (
    <>
      <Carousel fade>
        <Carousel.Item fade>
          <img
            className="w-100"
            id='mainImage'
            src={slide1}
            alt="First slide"
          />
          <NavigationBar />
          <NewNav />

          <Carousel.Caption>
            <Row>
              <Col  id="carouselCol" >
                <h1 data-aos="zoom-in" id="headingOne">Time To Discover</h1>
                <h1 data-aos="zoom-in" id="headingTwo">Perkleaf cafe</h1>
                <p className="hero-text">
                  Cold brew coffee for hot summer or perfect filter coffee from fresh roasted<br />
                  sorts of craft bean are always in in our cafe.
                </p>
                <Button id="btn0" variant="primary" onClick={Move}>
                  Taste Coffee
                </Button>
              </Col>
            </Row>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item fade>
          <img
            // className="d-block w-100"
            className="w-100"
            id='mainImage'
            src={slide2}
            alt="Second slide"

          />
          <NavigationBar />
          <NewNav />
          <Carousel.Caption>
            <Row>
              <Col id="carouselCol">
                <h1 data-aos="zoom-in" id="headingOne">Best Coffee</h1>
                <h1 data-aos="zoom-in" id="headingTwo">Great Company</h1>
                <p className="hero-text">
                  Cold brew coffee for hot summer or perfect filter coffee from fresh roasted<br />
                  sorts of craft bean are always in in our cafe.
                </p>
                <Button id="btn0" variant="primary" onClick={Move}>
                  Taste Coffee
                </Button>
              </Col>
            </Row>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item fade>
          <img
            // className="d-block w-100"
            src={slide3}
            alt="Third slide"
            id='mainImage'
            className="w-100"
          />
          <NavigationBar />
          <NewNav />
          <Carousel.Caption>
            <Row>
              <Col id="carouselCol" >
                <h1 data-aos="zoom-in" id="headingOne">Fresh Brews</h1>
                <h1 data-aos="zoom-in" id="headingTwo">Warm Vibes</h1>
                <p className="hero-text">
                  Cold brew coffee for hot summer or perfect filter coffee from fresh roasted<br />
                  sorts of craft bean are always in in our cafe.
                </p>
                <Button id="btn0" variant="primary" onClick={Move}>
                  Taste Coffee
                </Button>
              </Col>
            </Row>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item fade>
          <img
            // className="d-block w-100"
            src={slide4}
            alt="Fourth slide"
            id='mainImage'
            className="w-100"
          />
          <NavigationBar />
          <NewNav />
          <Carousel.Caption>
            <Row>
              <Col id="carouselCol" >
                <h1 data-aos="zoom-in" id="headingOne">Rich Taste</h1>
                <h1 data-aos="zoom-in" id="headingTwo">Great Aroma</h1>
                <p className="hero-text">
                  Cold brew coffee for hot summer or perfect filter coffee from fresh roasted<br />
                  sorts of craft bean are always in in our cafe.
                </p>
                <Button id="btn0" variant="primary" onClick={Move}>
                  Taste Coffee
                </Button>
              </Col>
            </Row>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item fade>
          <img
            // className="d-block w-100"
            src={slide5}
            alt="Fifth slide"
            id='mainImage'
            className="w-100"
          />
          <NavigationBar />
          <NewNav />
          <Carousel.Caption>
            <Row>
              <Col id="carouselCol" >
                <h1 data-aos="zoom-in" id="headingOne">More Beans</h1>
                <h1 data-aos="zoom-in" id="headingTwo">More Taste</h1>
                <p className="hero-text">
                  Cold brew coffee for hot summer or perfect filter coffee from fresh roasted<br />
                  sorts of craft bean are always in in our cafe.
                </p>
                <Button id="btn0" variant="primary" onClick={Move}>
                  Taste Coffee
                </Button>
              </Col>
            </Row>
          </Carousel.Caption>
        </Carousel.Item>
      </Carousel>

      <Container fluid id='containerOne'>
        <Row>
          <Col style={{ textAlign: "center", margin: "5% 0%" }}>
            <span data-aos="zoom-in-up" style={{ color: "#4d8b55", fontWeight: "bold" }}>Perkleaf Menu</span>
            <h1 data-aos="zoom-in-up" style={{ fontFamily: "san-serif", fontWeight: "bold" }}>Tasty Products</h1>
          </Col>
        </Row>
        <Row>
          <Col md={12} style={{ justifyContent: "center", gap: "20px" }}>
            <Row>
              {menu.map((p) => (
                <Col data-aos="zoom-in-up" xs={6} md={3} key={menu.id} style={{ marginTop: "20px", textAlign: "center", gap: "20px" }}>
                  <Card style={{ border: "none" }}>
                    <a href={p.link} style={{ textDecoration: "none", color: "black" }}>
                      <Card.Img id='imageCard'
                        src={p.image} />
                      <Card.Body>
                        <Card.Title id='titleCard'>{p.name}</Card.Title>
                        <Card.Text id='textCard'>{p.description}</Card.Text>
                      </Card.Body>
                    </a>
                  </Card>
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
      </Container>
      <br></br><br></br>
      <Container fluid id='containertwo'>
        <Container>
          <Row>
            <Col md={6} xs={12} style={{ color: "white" }}>
              <Row>
                <h1  data-aos="fade-right">
                  <p id='cont2p' style={{ color: "#4d8b55", margin: "0px" }}>Roasted Coffee</p>
                  <span id='cont2p' >for Your Mood</span>
                </h1>
              </Row>
              <Row>
                <Col><p>Discover the art of coffee, crafted with 100% Arabica beans.
                  Our café blends rich flavor, cozy ambiance, and warm hospitality.</p></Col>
              </Row>
              <Row>
                <Col id='add'>
                  <div id='icon'><img id='iconsize' src={icon} /></div>
                  <div id='address'>
                    <span style={{ display: "block", color: "#4D8B55", fontWeight: "bold" }}>Our Location</span>
                    <span>Perkleaf Cafe, Medical Chowk , Near LOC Cafe , Nagpur- 440009</span>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col md={6} xs={12} style={{ marginTop: "3%" }}>
                  <Button id='btn1' variant="primary" onClick={Read}>Read More</Button>
                </Col>
                <Col md={6} xs={12} style={{ marginTop: "3%" }}>
                  <Button id='btn2' variant="primary" onClick={Con}>Contact us</Button>
                </Col>
              </Row>
            </Col>
            <Col id='stampCol'>
              <img id='stamp' src={stamp} />
            </Col>
          </Row>
        </Container>
      </Container>

      <Container fluid id='containerThree'>
        <Col style={{ textAlign: "center" }}>
          <h2 style={{ fontFamily: "san-serif", fontWeight: "bold", color: "white", marginBottom: "2%" }}>Coffee - From Tree To Mug</h2>
        </Col>
        <Row>
          <Col  id='beanid' md={4} xs={6}>
            <div data-aos="zoom-in-right" id='beanDiv' ><img style={{ width: "40%" }} src={step1} />
              <p id='beanName'>Coffee Tree</p>
            </div>
          </Col>
          <Col id='beanid' md={4} xs={6}>
            <div data-aos="zoom-out" id='beanDiv'><img style={{ width: "40%" }} src={step2} />
              <p id='beanName'>Hand-picked Cherries</p>
            </div>
          </Col>
          <Col id='beanid2' md={4} xs={6}>
            <div data-aos="zoom-in-left" id='beanDiv'><img style={{ width: "40%" }} src={step3} />
              <p id='beanName'>Green Beans</p>
            </div>
          </Col>
          <Col id='beanid' md={4} xs={6}>
            <div  data-aos="zoom-in-right"  id='beanDiv'><img style={{ width: "40%" }} src={step4} />
              <p id='beanName'>Roasted Coffee Beans</p>
            </div>
          </Col>
          <Col id='beanid' md={4} xs={6}>
            <div  data-aos="zoom-out" id='beanDiv'><img style={{ width: "45%" }} src={step5} />
              <p id='beanName'>Coffee Powder</p>
            </div>
          </Col>
          <Col id='beanid2' md={4} xs={6}>
            <div  data-aos="zoom-in-left" id='beanDiv'><img style={{ width: "30%" }} src={step6} />
              <p id='beanName'>Aromatic cup of Coffee</p>
            </div>
          </Col>


        </Row>
      </Container>

      <Container fluid id='containerFour'>
        <Row>
          <Col style={{ textAlign: "center", margin: "5% 0%" }}>
            <span style={{ color: "#4d8b55", fontWeight: "bold" }}>Perkleaf menu</span>
            <h1 style={{ fontFamily: "san-serif", fontWeight: "bold" }}>Coffee House</h1>
          </Col>
        </Row>
        <Row>
          <Col  md={6} xs={12}>
            <div data-aos="fade-up" id='menuDiv'>
              <div id='menuImage'><img style={{ width: "80%", height: "100%" }} src={one} /></div>
              <div id='menuDisc'>
                <div>
                  <h6 id='menuName'>Doppio
                  </h6>

                </div>
                <div id='menucontent'><p> 100% Natural Arabica | Coffee 100% | 60 ml cup</p></div>
              </div>
              <div id='menuPrice'><span id='menuCost'>₹130</span></div>
            </div>

            <div  data-aos="fade-up" id='menuDiv'>
              <div id='menuImage'><img style={{ width: "80%", height: "100%" }} src={two} /></div>
              <div id='menuDisc'>
                <div>
                  <h6 id='menuName'>Americano
                  </h6>

                </div>
                <div id='menucontent'><p>Coffee 33%, Hot Water 67% | 150 ml cup</p></div>
              </div>
              <div id='menuPrice'><span id='menuCost'>₹140</span></div>
            </div>

            <div data-aos="fade-up" id='menuDiv'>
              <div id='menuImage'><img style={{ width: "80%", height: "100%" }} src={three} /></div>
              <div id='menuDisc'>
                <div>
                  <h6 id='menuName'>Cappucino
                  </h6>

                </div>
                <div id='menucontent'><p>Coffee 30%, Milk 70% (incl. foam) | 180 ml</p></div>
              </div>
              <div id='menuPrice'><span id='menuCost'> ₹160</span></div>
            </div>

            <div data-aos="fade-up" id='menuDiv'>
              <div id='menuImage'><img style={{ width: "80%", height: "100%" }} src={four} /></div>
              <div id='menuDisc'>
                <div>
                  <h6 id='menuName'>Latte
                  </h6>

                </div>
                <div id='menucontent'><p>Coffee 20%, Milk 80% | 200 ml</p></div>
              </div>
              <div id='menuPrice'><span id='menuCost'>₹170</span></div>
            </div>
          </Col>
          <Col md={6} xs={12}>
            <div data-aos="fade-up" id='menuDiv'>
              <div id='menuImage'><img style={{ width: "80%", height: "100%" }} src={one} /></div>
              <div id='menuDisc'>
                <div>
                  <h6 id='menuName'>Flat White
                  </h6>

                </div>
                <div id='menucontent'><p> Coffee 40%, Milk 60% | 180 ml</p></div>
              </div>
              <div id='menuPrice'><span id='menuCost'>₹180</span></div>
            </div>

            <div data-aos="fade-up" id='menuDiv'>
              <div id='menuImage'><img style={{ width: "80%", height: "100%" }} src={two} /></div>
              <div id='menuDisc'>
                <div>
                  <h6 id='menuName'>Irish Cream Latte
                  </h6>

                </div>
                <div id='menucontent'><p>Coffee 20%, Milk 60%, Irish Cream 20% | 200 ml</p></div>
              </div>
              <div id='menuPrice'><span id='menuCost'>₹200</span></div>
            </div>

            <div data-aos="fade-up" id='menuDiv'>
              <div id='menuImage'><img style={{ width: "80%", height: "100%" }} src={three} /></div>
              <div id='menuDisc'>
                <div>
                  <h6 id='menuName'>Caramel Latte
                  </h6>

                </div>
                <div id='menucontent'><p>Coffee 20%, Milk 60%, Caramel 20% | 200 ml</p></div>
              </div>
              <div id='menuPrice'><span id='menuCost'>₹190</span></div>
            </div>

            <div data-aos="fade-up" id='menuDiv'>
              <div id='menuImage'><img style={{ width: "80%", height: "100%" }} src={four} /></div>
              <div id='menuDisc'>
                <div>
                  <h6 id='menuName'>Mocha
                  </h6>

                </div>
                <div id='menucontent'><p>Coffee 30%, Milk 50%, Chocolate 20% | 200 ml</p></div>
              </div>
              <div id='menuPrice'><span id='menuCost'>₹200</span></div>
            </div>
          </Col>
        </Row>
      </Container>
      </>
  );
}

export default Home;